const hardcodedVouchEvangelistCustomerId =
  "03134b0b-9e52-480d-96eb-d93b3dc5e465";
const hardcodedVouchDatasourceId = "12ea08f3-ae24-4bce-bf2c-6f59459b40b2";
const hardcodedVouchProveUrl = "https://app.getvouch.io/start";

const base64url = (str: string) =>
  btoa(str).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");

export function getVouchUrl({
  verificationId,
  redirectUrlPathname,
  redirectUrlSearchParams,
  handle,
}: {
  verificationId: string;
  redirectUrlPathname: string;
  redirectUrlSearchParams: URLSearchParams;
  handle: string;
}) {
  const config = useRuntimeConfig();
  // we do not use this value for anything
  const requestId = window.crypto.randomUUID();
  const redirectBackUrl = new URL(window.location.href);
  redirectBackUrl.pathname = redirectUrlPathname;
  redirectUrlSearchParams.set("verificationId", verificationId);
  redirectBackUrl.search = redirectUrlSearchParams.toString();

  // vouch callback can not be localhost
  const webhookBaseUrl = config.public.APP_API_URL.includes("localhost")
    ? "https://appapi.dev.evangelist.gg"
    : config.public.APP_API_URL;
  const webhookUrl = `${webhookBaseUrl}/callback/vouch/follow/${verificationId}`;

  const params = {
    requestId,
    customerId: hardcodedVouchEvangelistCustomerId,
    datasourceId: hardcodedVouchDatasourceId,
    redirectBackUrl: redirectBackUrl.toString(),
    webhookUrl,
    inputs: base64url(
      JSON.stringify({ twitter_username: handle.toLowerCase() }),
    ),
  };
  console.log("vouch params", params);

  return hardcodedVouchProveUrl + "?" + new URLSearchParams(params).toString();
}
